import { Option } from '@spike/model';
import styles from './ListItem.module.scss';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { FunctionComponent } from 'react';

interface ListItemProps {
    label: string;
    selected: boolean;
    className?: string;
    onClick?: (selected: boolean) => void;
}

export const ListItem: FunctionComponent<ListItemProps> = props => {
    const clickHandler = () => {
        props.onClick?.(!props.selected);
    };

    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={clickHandler}
        >
            <FontAwesomeIcon
                icon={props.selected ? faSquareCheck : faSquare}
                fontSize={18}
            />
            <span className={styles.label}>{props.label}</span>
        </div>
    );
};

export default ListItem;
